import { Button, Radio } from "antd";
import styled from "styled-components";

export const RootContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 100%;
  grid-auto-rows: auto minmax(10px, 100%);
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const EntityWrapper = styled.div`
  max-width: 100%;
  flex-grow: 1000;
  width: 25%;
  min-width: 140px;
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  flex-grow: 1;
  justify-content: flex-end;

  label {
    color: black;
  }
`;

export const StyledRadioGroup = styled(Radio.Group)`
  margin-top: 22px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #d9d9d9; /* Add outer border to the group */
  min-width: 135.58px;

  .ant-radio-button-wrapper {
    border: none !important; /* Remove all borders */
    border-radius: 0;
    position: relative;

    &:first-child {
      border-radius: 6px 0 0 6px;
    }

    &:last-child {
      border-radius: 0 6px 6px 0;
    }

    &:only-child {
      border-radius: 6px;
    }

    /* Remove all pseudo-elements and focus states */
    &::before,
    &::after {
      display: none !important;
    }

    &:focus,
    &:focus-within,
    &:active {
      border: none !important;
      outline: none !important;
      box-shadow: none !important; /* Remove the drop shadow */
    }

    /* Also remove box-shadow on checked state */
    &.ant-radio-button-wrapper-checked {
      box-shadow: none !important;
    }

    /* Remove box-shadow on hover */
    &:hover {
      box-shadow: none !important;
    }
  }
`;

export const CopyContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .ant-typography {
    margin: 0;
  }
`;

export const CopyButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
